<template>
  <div class="cargoWarehousingException">
    <van-form label-width="100px">
      <van-field
        v-model="form.StateName"
        :label="$t.cargoWarehousing.deliveryExceptionReason"
        readonly
        type="textarea"
        rows="3"
      />

      <div class="cargoWarehousingException-radio">
        <div class="radio-label">{{ $t.cargoWarehousing.exceptionHandling }}</div>
        <van-radio-group v-model="form.ExceptionHandling" direction="horizontal">
          <van-radio :name="1">{{ $t.cargoWarehousing.eState1 }}</van-radio>
          <van-radio :name="2">{{ $t.cargoWarehousing.eState2 }}</van-radio>
        </van-radio-group>
      </div>

      <div v-if="form.ExceptionHandling == 1">
        <van-field
          :value="
            $t.cargoWarehousing.exceptionText(
              form.TransferDeliveryCount ? form.TransferDeliveryCount : 0
            )
          "
          :label="$t.cargoWarehousing.exceptionNotice"
          readonly
          type="textarea"
          rows="3"
          class="red-field"
        />

        <van-field
          v-model="form.CRIdStr"
          :label="$t.cargoWarehousing.exceptionAddress"
          @click="onShowEmit('showExceptionAddress')"
          :placeholder="$t.meta.select"
          clickable
          readonly
          required
          type="textarea"
          rows="3"
        >
          <template #button>
            <van-button
              size="small"
              type="info"
              @click="gotoEditAddress"
              v-if="form.CRId"
              >{{ $t.meta.edit }}</van-button
            >
          </template>
        </van-field>

        <van-field
          v-model="form.EMIdStr"
          :label="$t.cargoWarehousing.deliverer"
          @click="onShowEmit('showExceptionDeliverer')"
          :placeholder="$t.meta.select"
          clickable
          readonly
          required
        />
      </div>
      <div style="margin: 16px">
        <van-button round block type="info" @click="onSubmit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <option-list
      event="showExceptionAddress"
      :options="addressList"
      @onSelect="addressConfirm"
    ></option-list>

    <option-list
      event="showExceptionDeliverer"
      :options="employeeList"
      @onSelect="employConfirm"
    ></option-list>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Radio, RadioGroup } from "vant";
import OptionList from "@components/optionList/OptionList.vue";

Vue.use(Form).use(Field).use(Button).use(Radio).use(RadioGroup);

export default {
  name: "warehouseSettingsDetail",
  components: {
    OptionList,
  },
  data() {
    return {
      WB_Id: "",
      form: {
        //显示
        StateName: "",
        TransferDeliveryCount: null,
        //提交
        WB_Id: null,
        ExceptionHandling: null,
        CustomerId: null,
        //地址
        CRId: null,
        CRIdStr: "",
        //派送员
        EMId: null,
        EMIdStr: "",
      },
      addressList: [],
      originAddressList: [],
      employeeList: [],
    };
  },
  created() {
    const { WB_Id } = this.$route.query;
    this.WB_Id = WB_Id;
    this.getOrderDeliveryExceptionHandlingByWB_Id().then((success) => {
      if (success) {
        if (this.form.CustomerId) {
          this.getCustomerReceivingList();
        }
        this.getExpressEmployeeList(2);
      }
    });
  },
  methods: {
    gotoEditAddress() {
      var data = {};
      for (var address of this.originAddressList) {
        if (address.CRId == this.form.CRId) {
          data = address;
        }
      }
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "cargoWarehousingEditAddress",
        name: "cargoWarehousingEditAddress",
        query: [
          {
            name: "Address",
            value: data,
          },
        ],
      });
    },
    addressConfirm(e) {
      this.form.CRIdStr = e.text;
      this.form.CRId = e.value;
      this.$forceUpdate();
    },
    employConfirm(e) {
      this.form.EMIdStr = e.text;
      this.form.EMId = e.value;
      this.$forceUpdate();
    },
    getOrderDeliveryExceptionHandlingByWB_Id() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          WB_Id: this.WB_Id,
        };
        this.$api.storage
          .getOrderDeliveryExceptionHandlingByWB_Id(param)
          .then((res) => {
            this.form = res.data;
            this.form.ExceptionHandling = 1;
            if (this.form.CRId) {
              this.form.CRIdStr =
                res.data.ReceivingName +
                " , " +
                res.data.PhoneNumber +
                " , " +
                res.data.ReceivingAddress;
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    getCustomerReceivingList() {
      return new Promise((resolve) => {
        var param = {
          CustomerId: this.form.CustomerId,
          IsLocked: 0,
        };
        this.$api.storage
          .getCustomerReceivingList(param)
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text:
                  item.ReceivingName +
                  " , " +
                  item.PhoneNumber +
                  " , " +
                  item.ReceivingAddress,
                value: item.CRId,
              };
              result.push(data);
            });
            this.addressList = result;
            this.originAddressList = res.data;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getExpressEmployeeList(role) {
      return new Promise((resolve) => {
        var param = {
          EmployeeRole: role,
          IsLocked: 0,
        };
        this.$api.storage
          .getExpressEmployeeListByPage(param)
          .then((res) => {
            var result = [];
            res.data.Data.forEach((item) => {
              let data = {
                text: item.FullName + " , " + item.PhoneNumber,
                value: item.EMId,
              };
              result.push(data);
            });
            this.employeeList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    onSubmit() {
      if (this.form.ExceptionHandling == 1 && this.form.TransferDeliveryCount == 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.cargoWarehousing.exceptionTrim,
          type: "error",
        });
        return;
      }

      this.$commonMethod.showLoading();
      var param = {
        WB_Id: this.form.WB_Id,
        ExceptionHandling: this.form.ExceptionHandling,
      };
      if (this.form.ExceptionHandling == 1) {
        param.CRId = this.form.CRId;
        param.EMId = this.form.EMId;
      }
      this.$api.storage
        .saveCargoExceptionHandlingByWB_Id(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.cargoWarehousingException {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .red-field {
    ::v-deep .van-field__control {
      color: red !important;
    }
  }
  .cargoWarehousingException-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
}
</style>
